import React from 'react';
import {render} from 'react-dom';
import './styles/style.scss';
import EAIWrapper from './components/EAIWrapper';
import ZoneWrapper from './components/ZoneWrapper';
//import reportWebVitals from './reportWebVitals';

render(<EAIWrapper />, document.getElementById('es_risk_calc_eai'));
render(<ZoneWrapper />, document.getElementById('es_risk_calc_zone'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
